import { AuthServiceProvider } from "../auth";

export class AuthModel {
  // optional for testing purposes only
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private authData?: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(authData: any = {}) {
    this.authData = authData;
  }

  get provider(): AuthServiceProvider {
    return this.authData?.provider;
  }

  get token(): string {
    switch (this.authData?.provider) {
      case "google":
        return this.authData?.authentication?.idToken || this.authData?.["google/token"];
      case "cognito":
        return this.authData?.idToken?.jwtToken || this.authData?.["cognito/token"];
      default:
        return "";
    }
  }

  get refreshTokenExpiration(): number | undefined {
    switch (this.authData?.provider) {
      case "cognito":
        return this.authData?.refreshTokenExpiration;
      default:
        return undefined;
    }
  }

  // TODO: remove `profilePhoto` once `/api/admin/me` updated to return image url similar to `/api/sub/me`
  // We need to display the image that is driven by BE logic (accounting for both Google or Cognito/Cloudinary images)
  get profilePhoto(): string {
    return this.authData?.photoUrl || this.authData["google/image"] || "";
  }
}
